import axios from 'axios';
import config from 'api/urls-config.json';

export const getLegalInfoPage = params => {
    return axios.get(`${config.API + config.pages.legal_info}`, { params });
};

export const getTermsConditions = params => {
    return axios.get(`${config.API + config.pages.terms_conditions}`, { params });
};
